import CodeEmbed from './CodeEmbed';

class HistoricalCodeEmbed extends CodeEmbed {
  protected readonly disablePreviewing = true;
  protected readonly disableToolbar = true;
}

export default HistoricalCodeEmbed;
